import { InputFieldPropsType } from '../../../../components/fields/InputField';
import FlyingMoney from '../../../../assets/img/ops/flying-money.png';
import Refund from '../../../../assets/img/ops/refund.png';
import Accountant from '../../../../assets/img/ops/accountant.png';
import Bank from '../../../../assets/img/ops/bank.png';
import Transaction from '../../../../assets/img/ops/transaction-history.png';
import Bill from '../../../../assets/img/ops/bill.png';

export type ApisType = {
    id: string;
    name: string;
    icon: any;
    api: string;
    fields: InputFieldPropsType[]
}

export const apis:ApisType[] = [
    
    {
        id: '1',
        name: "Ven Fin Payment Requests",
        api: '/bulk/payment-requests',
        icon: Bill,
        fields: [
            {
                id: "file",
                variant: "auth",
                extra: "mb-3",
                label:"File",
                placeholder:"",
                type: 'file',
                required: true,
                accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
            }
        ]
    },
    {
        id: '2',
        name: "Direct Transfer Bulk",
        api: '/transfer/direct-bulk',
        icon: FlyingMoney,
        fields: [
            {
                id: "file",
                variant: "auth",
                extra: "mb-3",
                label:"File",
                placeholder:"",
                type: 'file',
                required: true,
                accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
            }
        ]
    },
   
    {
        id: '3',
        name: "Record Buyer Refunds",
        api: '/transfer/record-buyer-refunds',
        icon: Refund,
        fields: [
            {
                id: "file",
                variant: "auth",
                extra: "mb-3",
                label:"File",
                placeholder:"",
                type: 'file',
                required: true,
                accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
            }
        ]
    },
    {
        id: '4',
        name: "Create Accounts",
        api: '/ledger/accounts/import/bulk',
        icon: Accountant,
        fields: [
            {
                id: "file",
                variant: "auth",
                extra: "mb-3",
                label:"File",
                placeholder:"",
                type: 'file',
                required: true,
                accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
            }
        ]
    },
    {
        id: '5',
        name: "Create Originations",
        api: '/ledger/originations/import/bulk',
        icon: Bank,
        fields: [
            {
                id: "file",
                variant: "auth",
                extra: "mb-3",
                label:"File",
                placeholder:"",
                type: 'file',
                required: true,
                accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
            }
        ]
    },
    {
        id: '6',
        name: "B2B Update Txns Via Ops File",
        api: '/b2b/update-transactions',
        icon: Transaction,
        fields: [
            {
                id: "file",
                variant: "auth",
                extra: "mb-3",
                label:"File",
                placeholder:"",
                type: 'file',
                required: true,
                accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
            }
        ]
    },
];
